package com.essntl.features.service.ui.components.richtext

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.destructive.EsMediumDestructiveButton
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.input.EsInput
import com.mohamedrejeb.richeditor.model.RichTextState

@Composable
fun RichEditorLinkDialog(
    state: RichTextState,
    onDismissRequest: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var text by remember { mutableStateOf(state.selectedLinkText.orEmpty()) }
    var link by remember { mutableStateOf(state.selectedLinkUrl.orEmpty()) }

    EsDialog(
        title = "Add link",
        onDismissRequest = onDismissRequest,
        modifier = modifier,
    ) {
        Column(
            modifier =
                Modifier
                    .padding(20.dp),
        ) {
            EsInput(
                value =
                    if (state.selection.collapsed) {
                        text
                    } else {
                        state.annotatedString.text.substring(
                            state.selection.min,
                            state.selection.max,
                        )
                    },
                onValueChange = {
                    text = it
                },
                label = "Text",
                enabled = state.selection.collapsed && !state.isLink,
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(modifier = Modifier.height(20.dp))

            EsInput(
                value = link,
                onValueChange = {
                    link = it
                },
                label = "Link",
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(modifier = Modifier.height(20.dp))

            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier =
                    Modifier
                        .align(Alignment.End),
            ) {
                if (state.isLink) {
                    EsMediumDestructiveButton(
                        text = "Remove",
                        onClick = {
                            state.removeLink()

                            onDismissRequest()
                            text = ""
                            link = ""
                        },
                        modifier = Modifier,
                    )

                    Spacer(modifier = Modifier.width(10.dp))
                }

                EsMediumOutlineButton(
                    text = "Cancel",
                    onClick = {
                        onDismissRequest()
                        text = ""
                        link = ""
                    },
                    modifier = Modifier,
                )

                Spacer(modifier = Modifier.width(10.dp))

                EsMediumPrimaryButton(
                    text = "Save",
                    onClick = {
                        when {
                            state.isLink ->
                                state.updateLink(
                                    url = link,
                                )

                            state.selection.collapsed ->
                                state.addLink(
                                    text = text,
                                    url = link,
                                )

                            else ->
                                state.addLinkToSelection(
                                    url = link,
                                )
                        }

                        onDismissRequest()
                        text = ""
                        link = ""
                    },
                    enabled = (text.isNotEmpty() || !state.selection.collapsed) && link.isNotEmpty(),
                    modifier = Modifier,
                )
            }
        }
    }
}
